import { get, post } from '../request'

export const getEstimateById = (id) => get(`api/estimates/${id}`)
export const createEstimate = (params) => post('api/estimates', params)
